/**
 * TOSTO wishlist — localStorage (guest + per-customer key)
 */
(function () {
  var STORAGE_PREFIX = "tosto-wishlist-";

  function customerId() {
    var drawer = document.querySelector("[data-t-wish-drawer]");
    return (drawer && drawer.getAttribute("data-customer-id")) || "guest";
  }

  function storageKey() {
    return STORAGE_PREFIX + customerId();
  }

  function read() {
    try {
      var raw = localStorage.getItem(storageKey());
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    localStorage.setItem(storageKey(), JSON.stringify(list));
    syncUi();
  }

  function mergeGuestIntoCustomer() {
    var id = customerId();
    if (id === "guest") return;
    try {
      var guestRaw = localStorage.getItem(STORAGE_PREFIX + "guest");
      if (!guestRaw) return;
      var guest = JSON.parse(guestRaw);
      if (!Array.isArray(guest) || !guest.length) return;
      var current = read();
      var map = {};
      current.forEach(function (item) {
        map[item.handle] = item;
      });
      guest.forEach(function (item) {
        if (item && item.handle) map[item.handle] = item;
      });
      write(Object.keys(map).map(function (k) { return map[k]; }));
      localStorage.removeItem(STORAGE_PREFIX + "guest");
    } catch (e) {}
  }

  function isWished(handle) {
    return read().some(function (item) {
      return item.handle === handle;
    });
  }

  function toggle(item) {
    if (!item || !item.handle) return false;
    var list = read();
    var idx = list.findIndex(function (x) {
      return x.handle === item.handle;
    });
    if (idx >= 0) {
      list.splice(idx, 1);
      write(list);
      return false;
    }
    list.push({
      handle: item.handle,
      title: item.title || "",
      url: item.url || ("/products/" + item.handle),
      price: item.price || "",
      image: item.image || "",
    });
    write(list);
    return true;
  }

  function syncButtons() {
    document.querySelectorAll("[data-t-wish]").forEach(function (btn) {
      var handle = btn.getAttribute("data-handle");
      var on = handle && isWished(handle);
      btn.classList.toggle("is-on", !!on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function renderList() {
    var listEl = document.querySelector("[data-t-wish-list]");
    var emptyEl = document.querySelector("[data-t-wish-empty]");
    if (!listEl || !emptyEl) return;

    var list = read();
    listEl.innerHTML = "";

    if (!list.length) {
      emptyEl.hidden = false;
      listEl.hidden = true;
      return;
    }

    emptyEl.hidden = true;
    listEl.hidden = false;

    list.forEach(function (item) {
      var li = document.createElement("li");
      li.className = "t-wish__item";
      li.innerHTML =
        '<a class="t-wish__thumb" href="' +
        item.url +
        '">' +
        (item.image
          ? '<img src="' + item.image + '" alt="" width="80" height="100" loading="lazy">'
          : "") +
        "</a>" +
        '<div class="t-wish__meta">' +
        '<a class="t-wish__name" href="' +
        item.url +
        '">' +
        (item.title || item.handle) +
        "</a>" +
        (item.price ? '<p class="t-wish__price">' + item.price + "</p>" : "") +
        '<button type="button" class="t-wish__remove" data-t-wish-remove="' +
        item.handle +
        '">Eliminar</button>' +
        "</div>";
      listEl.appendChild(li);
    });
  }

  function syncUi() {
    syncButtons();
    renderList();
  }

  function openDrawer() {
    var root = document.querySelector("[data-t-wish-drawer]");
    if (!root) return;
    renderList();
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add("is-open");
    });
    document.body.style.overflow = "hidden";
    document.querySelectorAll("[data-t-wish-open]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "true");
    });
  }

  function closeDrawer() {
    var root = document.querySelector("[data-t-wish-drawer]");
    if (!root) return;
    root.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () {
      if (!root.classList.contains("is-open")) root.hidden = true;
    }, 280);
    document.querySelectorAll("[data-t-wish-open]").forEach(function (btn) {
      btn.setAttribute("aria-expanded", "false");
    });
  }

  window.TostoWishlist = {
    read: read,
    toggle: toggle,
    isWished: isWished,
    open: openDrawer,
    close: closeDrawer,
    sync: syncUi,
  };

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-t-wish-open]");
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var closeBtn = e.target.closest("[data-t-wish-close]");
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest("[data-t-wish-remove]");
    if (removeBtn) {
      e.preventDefault();
      toggle({ handle: removeBtn.getAttribute("data-t-wish-remove") });
      return;
    }

    var wishBtn = e.target.closest("[data-t-wish]");
    if (wishBtn) {
      e.preventDefault();
      e.stopPropagation();
      var on = toggle({
        handle: wishBtn.getAttribute("data-handle"),
        title: wishBtn.getAttribute("data-title"),
        url: wishBtn.getAttribute("data-url"),
        price: wishBtn.getAttribute("data-price"),
        image: wishBtn.getAttribute("data-image"),
      });
      wishBtn.classList.toggle("is-on", on);
      wishBtn.setAttribute("aria-pressed", on ? "true" : "false");
    }
  });

  document.addEventListener("keydown", function (e) {
    var root = document.querySelector("[data-t-wish-drawer]");
    if (e.key === "Escape" && root && root.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  mergeGuestIntoCustomer();
  syncUi();
})();
